import React, { useState } from "react";
import './caseStudyModal.css';

import{ init } from 'emailjs-com';
import * as emailjs from 'emailjs-com'
init("user_iLZ3jXyTzXi5zQFlgf5DG");

function CaseStudyModal() {
    const [formValues, setFormValues] = useState({
        name: '',
        company: '',
        email: '',
        phone: '',
        caseStudy: 'Best practices landscape rfps and water management'
    })

    const [submitted, setSubmitted] = useState(false);

    function submit(e) {

        setSubmitted(true);

        if(formValues.name.length > 0 && formValues.email.length > 0 && formValues.phone.length > 0) {
            // send form values via email        
            emailjs.send(
                'service_gekurtf',
                'template_y21szg9', //CONTACT TEMPLATE
                    formValues,
                    process.env.REACT_APP_REACTJS_USER
                )

            //creating an invisible element
            var element = document.createElement('a');
            element.setAttribute('href', `${process.env.PUBLIC_URL}/casestudies/${formValues.caseStudy}.pdf`);
            element.setAttribute('download', `${formValues.caseStudy}.pdf`);
        
            document.body.appendChild(element);
            
            //onClick property
            element.click();
        
            document.body.removeChild(element);
            
            // close modal
            window.$('#caseStudyModal').modal('hide');

            // reset form values
            setFormValues({
                name: '',
                company: '',
                email: '',
                phone: '',
                caseStudy: ''
            })
        }
    }


    return(
        <div className="modal fade" id="caseStudyModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">DOWNLOAD A CASE STUDY</h5>
                        <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" style={{border: '0px', backgroundColor: 'transparent'}}>X</button>
                    </div>
                    <div className="modal-body">
                        Select which case study you'd like to download:

                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="flexRadioDefault" id="Snow Case Study - Shoreline Schools final" checked={formValues.caseStudy === 'Snow Case Study - Shoreline Schools final'} onChange={(e) => setFormValues({...formValues, caseStudy: 'Snow Case Study - Shoreline Schools final'})} />
                            <label className="form-check-label" htmlFor="flexRadioDefault2">
                                Snow Case Study - Shoreline Schools final
                            </label>
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="flexRadioDefault" id="Snow Removal best practices - liability and risk management" checked={formValues.caseStudy === 'Snow Removal best practices - liability and risk management'} onChange={(e) => setFormValues({...formValues, caseStudy: 'Snow Removal best practices - liability and risk management'})} />
                            <label className="form-check-label" htmlFor="flexRadioDefault2">
                                Snow Removal best practices - liability and risk management
                            </label>
                        </div>

                        <hr />
                    
                        <form className="needs-validation" noValidate>
                            <label htmlFor="caseStudyCompany" className="form-label">Company:</label>
                            <input className="w-100 mb-2 form-control" value={formValues.company} id='caseStudyCompany' onChange={(e) => setFormValues({...formValues, company: e.target.value})} />

                            <label htmlFor="caseStudyName" className="form-label">Name: *</label>
                            <input className={formValues.name.length === 0 && submitted ? "w-100 mb-2 form-control is-invalid" : "w-100 mb-2 form-control"} value={formValues.name} id='caseStudyName' onChange={(e) => setFormValues({...formValues, name: e.target.value})} required />

                            <label htmlFor="caseStudyPhone" className="form-label">Phone: *</label>
                            <input value={formValues.phone} id="caseStudyPhone" onChange={(e) => setFormValues({...formValues, phone: e.target.value})} required className={formValues.phone.length === 0 && submitted ? "w-100 mb-2 form-control is-invalid" : "w-100 mb-2 form-control"}  />

                            <label htmlFor="caseStudyEmail" className="form-label">Email: *</label>
                            <input type='email' value={formValues.email}id="caseStudyEmail" onChange={(e) => setFormValues({...formValues, email: e.target.value})} required className={formValues.email.length === 0 && submitted ? "w-100 mb-2 form-control is-invalid" : "w-100 mb-2 form-control"}  />
                        </form>
                        <div className="modal-footer">
                            <button type="button" className='close-modal' data-dismiss="modal">CANCEL</button>
                            <button onClick={submit} type="submit" className='submit-modal'>SUBMIT</button>
                        </div>
                
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CaseStudyModal;